"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tarification = void 0;
class Tarification {
    constructor(json) {
        Object.assign(this, json);
    }
}
exports.Tarification = Tarification;
(function (Tarification) {
    Tarification.FlagsEnum = {
        MaleOnly: 'male_only',
        FemaleOnly: 'female_only',
        Deptkinesitherapy: 'deptkinesitherapy',
        Deptnursing: 'deptnursing',
        Deptgeneralpractice: 'deptgeneralpractice',
        Deptsocialworker: 'deptsocialworker',
        Deptpsychology: 'deptpsychology',
        Deptadministrative: 'deptadministrative',
        Deptdietetics: 'deptdietetics',
        Deptspeechtherapy: 'deptspeechtherapy',
        Deptdentistry: 'deptdentistry',
        Deptoccupationaltherapy: 'deptoccupationaltherapy',
        Depthealthcare: 'depthealthcare',
        Deptgynecology: 'deptgynecology',
        Deptpediatry: 'deptpediatry',
        Deptalgology: 'deptalgology',
        Deptanatomopathology: 'deptanatomopathology',
        Deptanesthesiology: 'deptanesthesiology',
        Deptbacteriology: 'deptbacteriology',
        Deptcardiacsurgery: 'deptcardiacsurgery',
        Deptcardiology: 'deptcardiology',
        Deptchildandadolescentpsychiatry: 'deptchildandadolescentpsychiatry',
        Deptdermatology: 'deptdermatology',
        Deptdiabetology: 'deptdiabetology',
        Deptemergency: 'deptemergency',
        Deptendocrinology: 'deptendocrinology',
        Deptgastroenterology: 'deptgastroenterology',
        Deptgenetics: 'deptgenetics',
        Deptgeriatry: 'deptgeriatry',
        Depthandsurgery: 'depthandsurgery',
        Depthematology: 'depthematology',
        Deptinfectiousdisease: 'deptinfectiousdisease',
        Deptintensivecare: 'deptintensivecare',
        Deptlaboratory: 'deptlaboratory',
        Deptmajorburns: 'deptmajorburns',
        Deptmaxillofacialsurgery: 'deptmaxillofacialsurgery',
        Deptmedicine: 'deptmedicine',
        Deptmolecularbiology: 'deptmolecularbiology',
        Deptneonatalogy: 'deptneonatalogy',
        Deptnephrology: 'deptnephrology',
        Deptneurology: 'deptneurology',
        Deptneurosurgery: 'deptneurosurgery',
        Deptnte: 'deptnte',
        Deptnuclear: 'deptnuclear',
        Deptnutritiondietetics: 'deptnutritiondietetics',
        Deptobstetrics: 'deptobstetrics',
        Deptoncology: 'deptoncology',
        Deptophtalmology: 'deptophtalmology',
        Deptorthopedy: 'deptorthopedy',
        Deptpalliativecare: 'deptpalliativecare',
        Deptpediatricintensivecare: 'deptpediatricintensivecare',
        Deptpediatricsurgery: 'deptpediatricsurgery',
        Deptpharmacy: 'deptpharmacy',
        Deptphysicalmedecine: 'deptphysicalmedecine',
        Deptphysiotherapy: 'deptphysiotherapy',
        Deptplasticandreparatorysurgery: 'deptplasticandreparatorysurgery',
        Deptpneumology: 'deptpneumology',
        Deptpodiatry: 'deptpodiatry',
        Deptpsychiatry: 'deptpsychiatry',
        Deptradiology: 'deptradiology',
        Deptradiotherapy: 'deptradiotherapy',
        Deptrevalidation: 'deptrevalidation',
        Deptrheumatology: 'deptrheumatology',
        Deptrhumatology: 'deptrhumatology',
        Deptsenology: 'deptsenology',
        Deptsocialservice: 'deptsocialservice',
        Deptsportsmedecine: 'deptsportsmedecine',
        Deptstomatology: 'deptstomatology',
        Deptsurgery: 'deptsurgery',
        Deptthoracicsurgery: 'deptthoracicsurgery',
        Depttoxicology: 'depttoxicology',
        Depttropicalmedecine: 'depttropicalmedecine',
        Depturology: 'depturology',
        Deptvascularsurgery: 'deptvascularsurgery',
        Deptvisceraldigestiveabdominalsurgery: 'deptvisceraldigestiveabdominalsurgery',
        Depttransplantsurgery: 'depttransplantsurgery',
        Deptpercutaneous: 'deptpercutaneous',
        Deptchildbirth: 'deptchildbirth',
    };
})(Tarification = exports.Tarification || (exports.Tarification = {}));
//# sourceMappingURL=Tarification.js.map